// 🧿 طلسم محافظ فایل

// UI Framework
import { toast } from "react-toastify";
import { TableCell } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
// Types
import { IOrderTableReport } from "src/Interfaces/automaticMarketMaking";
import { OrderStatus } from "src/Interfaces/orderInterfaces";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
// Requests
import { cancelOrder } from "src/Requests/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

const OrderTableAdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

const OrderTableAdditionalCol: React.FC<{
  row: IOrderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const cancelOrderHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    cancelOrder(row.id)
      .then((resp) => {
        if (resp.data) {
          onAction();
          toast.success(resp.msg);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell>
        {row.orderStatus !== OrderStatus.Cancelled ? (
          <div
            onClick={cancelOrderHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            <DeleteIcon
              fontSize="small"
              className="text-red-700 cursor-pointer"
            />
          </div>
        ) : null}
      </TableCell>
    </>
  );
};

export const OrderTableAdditional: IAdditional<IOrderTableReport> = {
  getHeader: OrderTableAdditionalHeader,
  getRow: OrderTableAdditionalCol,
};
